import MatxSuspense from "../MatxSuspense";
import useSettings from "../../Hooks/useSettings";
import { MatxLayouts } from "./index";

const MatxLayout = (props) => {
  const { settings } = useSettings();
  const Layout = MatxLayouts[settings.activeLayout];

  return (
    <MatxSuspense>
      <Layout {...props} />
    </MatxSuspense>
  );
};

export default MatxLayout;
